__turbopack_context__.v({
  "copy": "AccountMenu-module__VqObFW__copy",
  "description": "AccountMenu-module__VqObFW__description",
  "iconWrap": "AccountMenu-module__VqObFW__iconWrap",
  "item": "AccountMenu-module__VqObFW__item",
  "label": "AccountMenu-module__VqObFW__label",
  "menu": "AccountMenu-module__VqObFW__menu",
  "menuDrawer": "AccountMenu-module__VqObFW__menuDrawer",
  "menuPopover": "AccountMenu-module__VqObFW__menuPopover",
});
